<div class="bid-items-fields flex flex-col">
  <div class="bid-items-fields-content flex-1 flex flex-col min-h-0">
    <div class="flex justify-start items-center mb-[20px]">
      <div
        *ngIf="canEdit"
        (click)="addAccordion()"
        class="add-accordion-btn flex items-center gap-[8px] text-type-9 cursor-pointer"
      >
        <mat-icon svgIcon="blue-plus" class="add-icon"></mat-icon>
        Add field
      </div>
    </div>
    <div *ngFor="let group of accordionGroups" class="field-accordion">
    <div
      [class.is-expanded]="selectedAccordionId === group.id"
      [id]="group.id"
      class="field-accordion-wrapper border-[1px] border-[#C2C8DC] rounded-[4px] p-[16px]"
    >
      <div
        (click)="selectAccordion(group)"
        class="field-accordion-header flex justify-between items-center cursor-pointer"
      >
        <div class="field-accordion-heading text-type-13 uppercase">
          {{ getAccordionLabel(group) }}
        </div>
        <div class="flex items-center gap-[8px]">
          <mat-icon
            [svgIcon]="selectedAccordionId === group.id ? 'chevron-up' : 'chevron-down'"
            class="accordion-chevron"
          />
          <button
            *ngIf="canEdit"
            type="button"
            class="accordion-delete-btn flex items-center justify-center text-[#60698B] hover:text-[#E53935] transition-colors"
            (click)="confirmAndDeleteGroup(group); $event.stopPropagation()"
            title="Delete field"
          >
            <mat-icon svgIcon="trash" class="accordion-delete-icon"></mat-icon>
          </button>
        </div>
      </div>
      <div class="field-accordion-content">
        <app-fields-item
          [formGroup]="getFieldFormGroup(group)"
          [groupId]="group.id"
          [bidItemId]="data?.id"
          [canEdit]="canEdit"
          class="field-form-block mb-[40px]"
        />
      </div>
    </div>
  </div>
  </div>
</div>
